

import Swal from 'sweetalert2';
/**
 * SweetAlert2 Utility Functions
 *
 * Provides reusable alert and confirmation dialogs using SweetAlert2 for error, success, and mapping responses.
 *
 * Features:
 * - swlAlert: Shows error/success alerts and handles navigation or reload
 * - swlAlertMapping: Shows alerts for mapping responses, with optional redirection
 * - swlAlertConfirm: Shows confirmation dialogs with custom buttons and danger mode
 */
export const swlAlert = (response, url = null, navigate, reload = false) => {
    if (response.code === 0) {
        let message = response.message;
        let dataMessage = '';
        let dataErrors = response.data;

        for (const errorsKey in dataErrors) {
            if (!Object.prototype.hasOwnProperty.call(dataErrors, errorsKey)) continue;
            dataMessage += "\n" + dataErrors[errorsKey];
        }

        Swal.fire({
            title: message,
            text: dataMessage,
            icon: 'error',
        });

    } else {
        Swal.fire({
            title: response.message,
            icon: 'success',
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: 'btn btn-danger'
            },
        }).then((result) => {
            if (url && navigate) {
                navigate(url);
            } else if (url) {
                window.location.href = url;
            } else if (reload) {
                window.location.reload();
            }
        }).catch((error) => {
            console.error(error);
        });
    }
};

export const swlAlertMapping = (response, url = null) => {
    let message = response.message;
    let dataMessage = '';
    let dataErrors = response.data;

    for (const errorsKey in dataErrors) {
        if (!Object.prototype.hasOwnProperty.call(dataErrors, errorsKey)) continue;
        dataMessage += "\n" + dataErrors[errorsKey];
    }

    if (response.code === 0) {
        Swal.fire({
            title: message,
            text: dataMessage,
            icon: 'error',
        });
    } else {
        Swal.fire({
            title: response.message,
            text: dataMessage,
            icon: 'success',
        }).then((result) => {
            // Optional: handle redirection here if needed
            // if (url) {
            //   window.location.href = url;
            // }
        }).catch((error) => {
            console.error(error);
        });
    }
};

export const swlAlertConfirm = (title, text, icon, dangerMode, buttons) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: buttons[1],
        cancelButtonText: buttons[0],
        dangerMode: dangerMode,

    });
}

/**
 * Success alert that shows a generated password with a copy button.
 * Optionally redirects after the user confirms.
 */
export const swlAlertWithPassword = (response, url = null) => {
    if (response.code === 0) {
        swlAlert(response);
        return;
    }

    const password = response?.data?.key;
    if (!password) {
        swlAlert(response, url);
        return;
    }

    Swal.fire({
        title: response.message || 'User Added successfully.',
        icon: 'success',
        html: `
            <div class="text-center">
                <p class="mb-2 fw-semibold">Temporary Password</p>
                <div class="d-inline-flex align-items-center gap-2 px-3 py-2 border rounded bg-light">
                    <code id="swal-generated-password" class="fs-5 fw-bold text-dark user-select-all"></code>
                    <button type="button" id="swal-copy-password" class="btn btn-sm btn-light-primary btn-icon" title="Copy Password">
                        <i class="bi bi-clipboard fs-4"></i>
                    </button>
                </div>
                <p class="text-muted fs-7 mt-3 mb-0">Copy and share this password now. It will not be shown again.</p>
            </div>
        `,
        confirmButtonText: 'OK',
        customClass: {
            confirmButton: 'btn btn-danger',
        },
        didOpen: () => {
            const passwordEl = document.getElementById('swal-generated-password');
            const copyBtn = document.getElementById('swal-copy-password');
            if (passwordEl) {
                passwordEl.textContent = password;
            }
            copyBtn?.addEventListener('click', () => {
                navigator.clipboard.writeText(password).then(() => {
                    copyBtn.innerHTML = '<i class="bi bi-check2 fs-4 text-success"></i>';
                    setTimeout(() => {
                        copyBtn.innerHTML = '<i class="bi bi-clipboard fs-4"></i>';
                    }, 1500);
                }).catch(() => {
                    // Fallback for older browsers / denied clipboard
                    const range = document.createRange();
                    range.selectNodeContents(passwordEl);
                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                });
            });
        },
    }).then(() => {
        if (url) {
            window.location.href = url;
        }
    }).catch((error) => {
        console.error(error);
    });
};
